import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FadeInDelay, SlideUpAnimation } from '@sml/utility';
import { ButtonsModule } from '@sml/buttons';
import { IconsComponent } from '@sml/icons';
import { DialogSize } from './dialog.type';
import { SubHeaderComponent } from '@sml/sub-header';
type dialogViewType = 'default' | 'confirmation' | 'success' | 'error' | 'warning' | 'info' | 'custom' | 'full-screen';

@Component({
  selector: 'sml-dialog',
  standalone: true,
  imports: [CommonModule, IconsComponent, ButtonsModule, SubHeaderComponent],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  animations: [SlideUpAnimation, FadeInDelay],
  encapsulation: ViewEncapsulation.None
})
export class DialogComponent implements OnInit {

  ngOnInit(): void {
    this.checkWindowSize();
  }

  @Input() size: DialogSize | '' = 'md';
  @Input() dialogTitle = '';
  @Input() dialogTitlePosition = '';
  @Input() dialogHeaderContent = '';
  @Input() dialogHeaderContentPosition = '';
  @Input() hasHeader = false;
  @Input() hasBodyContent = false;
  @Input() hasConfirmationDialog = false;
  @Input() hasCloseButton = false;
  @Input() iconName = '';
  @Input() iconPosition = '';
  @Input() dialogType: dialogViewType | '' = 'default';
  @Input() customDialogBodySpacing = '';
  @Input() bodyClass = '';
  @Input() modalClass = '';
  @Input() borderType: 'flat' | 'rounded' = 'rounded';
  @Input() src=''
  @Input() showCloseButtonOnMobile:boolean=true
  @Input() mobileFilters=false
  @HostBinding("class.sml-modal") baseClass = true;
  @HostBinding('class.sml-modal-show') @Input() isOpen = false;
  @HostBinding('class.sml-dialog-default') get isDefault() { return this.dialogType === 'default'; }
  @HostBinding('class.sml-dialog-confirmation') get isConfirmation() { return this.dialogType === 'confirmation'; }
  @HostBinding('class.sml-dialog-success') get isSuccess() { return this.dialogType === 'success'; }
  @HostBinding('class.sml-dialog-error') get isError() { return this.dialogType === 'error'; }
  @HostBinding('class.sml-dialog-warning') get isWarning() { return this.dialogType === 'warning'; }
  @HostBinding('class.sml-dialog-info') get isInfo() { return this.dialogType === 'info'; }
  @HostBinding('class.sml-dialog-custom') get isCustom() { return this.dialogType === 'custom'; }
  @HostBinding('class.sml-dialog-full-screen') get isFullScreen() { return this.dialogType === 'full-screen'; }
  @Output() closed = new EventEmitter<void>();
  @Output() closeMobile = new EventEmitter<void>();
  @ViewChild('scrollContent') scrollContent!: ElementRef;


  constructor(@Inject(DOCUMENT) private readonly document: Document, @Inject(PLATFORM_ID) private readonly platformId: object,) { }

  closeModal(): void {
    this.isOpen = false;
    this.closed.emit();
  }
  closeModalMobile(){
    this.isOpen = false;
    this.closeMobile.emit();
  }
  openModal(): void {
    this.isOpen = true;
  }
  isMobileView = false;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkWindowSize();
  }


  checkWindowSize(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 768) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false
      }
    }
  }
  scrollToTop(): void {
    if (this.scrollContent) {
      this.scrollContent.nativeElement.scrollTo(0, 0);
    }
  }
}
